/* eslint-disable */
// @ts-nocheck

import React, { createContext, useState } from 'react'
import { Control, SubmitHandler, useForm } from 'react-hook-form'

import Fetching from '../../../components/misc/Fetching'
import StepsComponent from '../../../components/misc/StepsComponent'
import ProductForm from './ProductForm'
import ProductImg from './ProductImg'
import ProductTypeSelector from './ProductTypeSelector'

interface WizardInterface {
  action: Function
  closeModal: Function
  loading: boolean
}

interface ContextData {
  control?: Control
  stepUp?: Function
  stepDown?: Function
  watch: Function
  unregister: Function
}

const contextData: ContextData = { watch: () => {}, unregister: () => {} }

export const ProductContext = createContext(contextData)

const NewWizardContainer = ({
  action,
  closeModal,
  loading,
}: WizardInterface) => {
  const { control, handleSubmit, reset, watch, unregister } =
    useForm<Record<string, string | number>>()

  //Step Component Data-------------------------------------------------------------
  const [currentStep, setCurrentStep] = useState(0)
  const stepTitles = ['Tipo de Producto', 'Detalles del Producto', 'Imagen']

  const stepUp = () => setCurrentStep(currentStep + 1)
  const stepDown = () => {
    setCurrentStep(currentStep - 1)
  }
  //----------------------------------------------------------------------------------------

  //Form Handle -----------------------------------------------------------------------------
  const onSubmit: SubmitHandler<Record<string, string | number>> = (data) => {
    if (currentStep !== 2) {
      stepUp()
    } else {
      action(data, closeModal)
    }
  }

  //-----------------------------------------------------------------------------------------

  return (
    <>
      <StepsComponent current={currentStep} titles={stepTitles} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <ProductContext.Provider
          value={{ control, stepUp, stepDown, watch, unregister }}
        >
          {loading && <Fetching />}
          {currentStep === 0 && <ProductTypeSelector />}
          {currentStep === 1 && <ProductForm />}
          {currentStep === 2 && <ProductImg />}
        </ProductContext.Provider>
      </form>
    </>
  )
}

export default NewWizardContainer
